import Vue from 'vue'
import Router from 'vue-router'
// import Login from '@/components/Login'
import Login from '@/components/login_new'
import Infobot from '@/components/Infobot_new'
import Layout from '@/components/Layout'
import Createaccount from '@/components/Createaccount'
import Homepage from '@/components/Homepage'
import Chatlayout from '@/components/Chatlayout'
import Editprofile from '@/components/Editprofile'
import Infofriend from '@/components/Infofriend'
import Broadcast from '@/components/Broadcast'
import Addowner from '@/components/Addowner'
import Event from '@/components/Event'
import Eventfriend from '@/components/Eventfriend'
import Managefriend from '@/components/Managefriend'
import NotFound from '@/components/NotFound'
import NotPermission from '@/components/NotPermission'
import AutoReply from '@/components/Autoreply'
import Authen from '@/components/LayoutOnMobile/Authen'
import AuthenNoti from '@/components/LayoutOnMobile/AuthenNoti'
import ListChat from '@/components/LayoutOnMobile/ListChat'
import LayoutMobile from '@/components/LayoutOnMobile/LayoutMobile'
import Chat from '@/components/LayoutOnMobile/Chat'
import Info from '@/components/LayoutOnMobile/Infofriend'
import CreateAccount from '@/components/LayoutOnMobile/Createaccount'
import SettingEditprofile from '@/components/LayoutOnMobile/Editprofile'
import SettingAddowner from '@/components/LayoutOnMobile/Addowner'
import SettingManagefriend from '@/components/LayoutOnMobile/Managefriend'
import SettingBroadcast from '@/components/LayoutOnMobile/Broadcast'
import SettingAutoReply from '@/components/LayoutOnMobile/Autoreply'
import HomepageMobile from '@/components/LayoutOnMobile/Homepage'
import NotFoundMobile from '@/components/LayoutOnMobile/NotFound'
import NotPermissionMobile from '@/components/LayoutOnMobile/NotPermission'

import authen_callbackoneid from '@/components/authenCallbackOneid'

// import Test from '@/components/test'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', component: Layout },
    // { path: '/test', component: Test },
    { path: '/login', component: Login },
    // { path: '/login', component: Login2 },
    { path: '/authen', component: Authen },
    { path: '/authen_noti', component: AuthenNoti },
    { path: '/authorization/redirect', component: authen_callbackoneid },
    { path: '/layoutmobile',
      component: LayoutMobile,
      name: 'layoutmobile',
      children: [
        { path: '/listchat/:id', component: ListChat },
        { path: '/homepage-mobile', component: HomepageMobile },
        { path: '/chat-mobile/:id/:roomid', component: Chat },
        { path: '/infofriend-mobile/:id/:roomid', component: Info },
        { path: '/createaccount-mobile', component: CreateAccount },
        { path: '/settings-mobile/profile/:id', component: SettingEditprofile },
        { path: '/settings-mobile/addadmin/:id', component: SettingAddowner },
        { path: '/settings-mobile/managefriend/:id', component: SettingManagefriend },
        { path: '/settings-mobile/broadcast/:id', component: SettingBroadcast },
        { path: '/settings-mobile/autoreply/:id', component: SettingAutoReply },
        { path: '/chat-mobile/not_found', component: NotFoundMobile },
        { path: '/chat-mobile/not_permission', component: NotPermissionMobile }
      ],
      meta: { requiresAuthLogin: true }
    },
    {
      path: '/',
      name: 'layout',
      component: Layout,
      children: [
        { path: '/homepage', component: Homepage },
        { path: '/account/:id', component: Infobot },
        { path: '/create_account', component: Createaccount },
        { path: '/chat/:id/:roomid', component: Chatlayout },
        { path: '/infofriend/:id/:roomid', component: Infofriend },
        { path: '/account/settings/profile/:id', component: Editprofile },
        { path: '/account/settings/broadcast/:id', component: Broadcast },
        { path: '/account/settings/addadmin/:id', component: Addowner },
        { path: '/account/settings/event/:id', component: Event },
        { path: '/account/settings/managefriend/:id', component: Managefriend },
        { path: '/account/settings/autoreply/:id', component: AutoReply },
        { path: '/event/:id/:eventcategoryname/:eventid', component: Eventfriend },
        { path: '/chat/not_found', component: NotFound },
        { path: '/chat/not_permission', component: NotPermission }
      ],
      meta: { requiresAuth: true }
    },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((x) => x.meta.requiresAuth)) {
    if (localStorage.getItem('status_login') !== 'T' || localStorage.getItem('status_login') === null) {
      // set localStorage path redirect
      localStorage.setItem('path_redirect', router.history._startLocation)
      next({ path: '/login' })
    } else {
      next()
    }
    return
  }
  next()
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((x) => x.meta.requiresAuthLogin)) {
    if (localStorage.getItem('status_login') !== 'T' || localStorage.getItem('status_login') === null) {
      next({ path: '/authen' })
    } else {
      next()
    }
    return
  }
  next()
})

export default router
